import http from 'axios'
import urls from './manageUserGroups.urls'

export default {
  getUserGroups: ({ state, rootState, commit }) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .get(urls.getUserGroups)
      .then(response => {
        commit('setUserGroupsList', response.data)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  deactivateUserGroup: ({ state, rootState, commit, dispatch }, userGroup) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .delete(urls.changeUserGroup(userGroup.userGroupId))
      .then(response => {
        dispatch('getUserGroups')
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  getUserGroupDetails: ({ state, rootState, commit }, userGroupId) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .get(urls.changeUserGroup(userGroupId))
      .then(response => {
        commit('setUserGroupDetails', response.data)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  getTrackingGroups: ({ state, rootState, commit }, { search, clientName }) => {
    return http
      .get(urls.trackingGroups, { params: { clientName: clientName, search: search } })
      .then(response => {
        commit('setTrackingGroups', response.data)
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
      })
  },
  getBenefitGroups: ({ state, rootState, commit }, { search, clientName }) => {
    return http
      .get(urls.benefitGroups, { params: { clientName: clientName, search: search } })
      .then(response => {
        commit('setBenefitGroups', response.data)
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
      })
  },
  getParentGroups: ({ state, rootState, commit }, { search, clientName }) => {
    return http
      .get(urls.parentGroups, { params: { clientName: clientName, search: search } })
      .then(response => {
        commit('setParentGroups', response.data)
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
      })
  },
  viewGroupSummary: ({ state, rootState, commit }, { data, clientName }) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .post(urls.viewSummary, data, { params: { clientName: clientName } })
      .then(response => {
        commit('setGroupSummary', response.data)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  saveUserGroup: ({ state, rootState, commit, dispatch }, userGroupRequest) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return (userGroupRequest.userGroupId
      ? http.put(urls.changeUserGroup(userGroupRequest.userGroupId, userGroupRequest), userGroupRequest)
      : http.post(urls.addUserGroup, userGroupRequest))
      .then(response => {
        dispatch('getUserGroups')
        commit('global/setShowLoadingSpinner', false, { root: true })
        return response
      }, error => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
        throw error
      })
  }
}
